<template>
  <div class="btn-bottom">
    <div class="btn-fix">
      <a class="btn" :class="{'disabled': isReady}" @click.stop="toSave">{{title}}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '保存'
    },
    isReady: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    toSave() {
      this.$emit('submit')
    }
  }
}

</script>
<style scoped lang="less">
  .btn-bottom .disabled {
    background: #ccc;
    color: #000;
    opacity: 0.4;
  }
  .btn-bottom .btn-fix  {
    animation: accelerateAnim .1s both;
  }
  @-webkit-keyframes accelerateAnim {
    0%,to{
      transform:translateZ(0);
    }
  }
</style>
